export const APP_ENV = process.env.REACT_APP_ENV || ''
export const APP_NAME = process.env.REACT_APP_WEB_APP_NAME || ''
export const APP_VERSION = process.env.REACT_APP_VERSION || ''

export const MOCKED = process.env.REACT_APP_MOCKED

export const HEADER_LINK = process.env.REACT_APP_HEADER_LINK

export const FOOTER_EMAIL = process.env.REACT_APP_FOOTER_EMAIL
export const FOOTER_PHONE = process.env.REACT_APP_FOOTER_PHONE
export const CF_MUTUA = process.env.REACT_APP_CF_MUTUA
export const CF_VITA = process.env.REACT_APP_CF_VITA
export const CF_PATRIMONIO = process.env.REACT_APP_CF_PATRIMONIO
export const CF_VALPIAVE = process.env.REACT_APP_CF_VALPIAVE
export const PI_GRUPPO = process.env.REACT_APP_PI_GRUPPO
export const FOOTER_CLAIMS_EMAIL = process.env.REACT_APP_FOOTER_CLAIMS_EMAIL

export const SITE_KEY = process.env.REACT_APP_SITE_KEY
export const EFFECTIVE_DATE_DISABLED = process.env.REACT_APP_EFFECTIVE_DATE_DISABLED === 'true'
export const FASTQUOTE_NEW_START_DATE = process.env.REACT_APP_FASTQUOTE_NEW_START_DATE === 'true'
